import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(private readonly _injector: Injector) {}

  public handleError(error: Error | HttpErrorResponse): void {
    console.error('handleError', error);

    const errorMessage: string = 'An error has occurred; Please try again.';
    let errorDetail: string = '';

    if (error instanceof HttpErrorResponse) {
      // server side error
      let eventId = (error as any)?.error?.cdiEventId;
      if (error.status != null && error.status != undefined) {
        if (error.status === 0) {
          errorDetail = `System Not Available`;
        } else {
          if (error.error && error.status === 401) {
            errorDetail = '401. Authentication Failed. Please login.';
          } else if (error.error && error.status === 403) {
            errorDetail =
              '403. Authorization Failed. You do not have permissions to access resource.';
          } else if (error.error && error.status === 400) {
            eventId = this.generateGuid();
            errorDetail = `${this.parseBadRequest(error)}`;
          } else if (error.error && error.status === 404) {
            errorDetail = `Status Code: 404; Not Found`;
          } else if (error.error && error.status === 405) {
            errorDetail = `Status Code: 405; Method Not Allowed`;
          } else if (error.error && error.status === 429) {
            console.error('429', error);
          } else if (error.error && error.status === 500) {
            errorDetail = `${this.parseErrorMessage(error)}`;
          } else if (error.error && error.status === 513) {
            errorDetail = this.custom500Error(error.error, 513);
          } else if (error.error && error.status === 514) {
            errorDetail = this.custom500Error(error.error, 514);
          } else if (error.error && error.status === 515) {
            errorDetail = this.custom500Error(error.error, 515);
          } else if (error.error && error.status === 516) {
            errorDetail = this.custom500Error(error.error, 516);
          } else if (error.error && error.status === 517) {
            errorDetail = this.custom500Error(error.error, 517);
          } else if (error.error && error.status === 518) {
            errorDetail = this.custom500Error(error.error, 518);
          }
        }

        this.showErrorMessage([errorDetail], eventId);
      }
    } else {
      // client side error
      this.showErrorMessage([error.message], 'Cli');
    }
  }

  private showErrorMessage(message: string[], cdiEventId: string) {}

  private custom500Error(text: any, errorNumber: number): string {
    let message: string = '';
    try {
      message = `${text.message}`;
    } catch (error) {
      console.error('custom500Error', error);
    }
    return message;
  }

  private parseErrorMessage(err: HttpErrorResponse): string {
    let message: string = '';
    try {
      if (err.error != null && err.error != undefined) {
        if (
          (err.error.circanaEventId === null ||
            err.error.ciranaEventId === undefined) &&
          (err.error.message === null || err.error.message === undefined)
        ) {
          message = `${err.error}`;
        } else {
          message = `${err.error.message}`;
        }
      }
    } catch (error) {
      console.error('parseErrorMessage', error);
      return 'unavailable.';
    }
    return message;
  }

  private parseBadRequest(err: any): string {
    let errorMessage: string = 'Validation Error';
    try {
      if (err.error != null && err.error != undefined) {
        if (
          err?.error?.title?.includes('One or more validation errors occurred')
        ) {
          errorMessage = `One or more validation errors occurred.\n ${this.parseValidationError(
            err.error.errors
          )}`;
        }
      }
    } catch (error) {
      console.error('parseBadRequest', error);
      return 'unavailable.';
    }
    return errorMessage;
  }

  private parseValidationError(data: any): string {
    let validationErrors: string = '';
    try {
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          validationErrors = validationErrors + `${data[key]}\n`;
        }
      }
    } catch (error) {
      console.error('parseValidationError', error);
      return 'Unable to Parse Validation Error';
    }
    return validationErrors;
  }

  private generateGuid(): string {
    let guid: string = '';
    try {
      guid = crypto.randomUUID();
    } catch (error) {
      console.error('generateGuid()', error);
    }
    return guid;
  }
}
